import {
  Button,
  ColumnLayout,
  Container,
  FormField,
  Header,
  Input,
} from '@cloudscape-design/components';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

export default function CustomsItem({ itemIdx, disableItemEdit = false }) {
  const {
    values: { customsItems = [] }, setFieldValue, errors,
  } = useFormikContext();

  const item = customsItems[itemIdx] || {};
  const error = errors.customsItems?.[itemIdx] || {};

  return (
    <Container
      header={(
        <Header
          variant="h3"
          actions={itemIdx !== 0 && !disableItemEdit && (
            <Button
              type="button"
              onClick={() => {
                const updatedCustomsItems = customsItems.filter((_, i) => i !== itemIdx);
                setFieldValue('customsItems', updatedCustomsItems);
              }}
            >
              Delete Item
            </Button>
          )}
        >
          {`Item ${itemIdx + 1}`}
        </Header>
)}
    >
      <ColumnLayout columns={2}>
        <FormField label="Description of Item" errorText={error.description}>
          <Input
            placeholder="PLASTICS AND ARTICLES THEREOF---OTHER"
            value={item.description}
            onChange={({ detail }) => { setFieldValue(`customsItems[${itemIdx}].description`, detail.value); }}
          />
        </FormField>
        <FormField label="Origin Country" errorText={error.origin_country}>
          <Input
            placeholder="2 letter code"
            value={item.origin_country}
            onChange={({ detail }) => { setFieldValue(`customsItems[${itemIdx}].origin_country`, detail.value); }}
          />
        </FormField>
        <FormField label="Quantity" errorText={error.quantity}>
          <Input
            value={item.quantity}
            onChange={({ detail }) => { setFieldValue(`customsItems[${itemIdx}].quantity`, detail.value); }}
          />
        </FormField>
        <FormField label="Total Weight (oz)" errorText={error.weight}>
          <Input
            value={item.weight}
            onChange={({ detail }) => { setFieldValue(`customsItems[${itemIdx}].weight`, detail.value); }}
          />
        </FormField>
        <FormField label="Total Value" errorText={error.value}>
          <Input
            placeholder="Unit Value * Quantity"
            value={item.value}
            onChange={({ detail }) => { setFieldValue(`customsItems[${itemIdx}].value`, detail.value); }}
          />
        </FormField>
        <FormField label="Currency" errorText={error.currency}>
          <Input
            placeholder="3-letter code, e.g. USD"
            value={item.currency}
            onChange={({ detail }) => { setFieldValue(`customsItems[${itemIdx}].currency`, detail.value); }}
          />
        </FormField>
        <FormField label="Harmonized Tariff Schedule" errorText={error.hs_tariff_number}>
          <Input
            placeholder='e.g. "3926.90" for PLASTICS AND ARTICLES THEREOF---OTHER'
            value={item.hs_tariff_number}
            onChange={({ detail }) => { setFieldValue(`customsItems[${itemIdx}].hs_tariff_number`, detail.value); }}
          />
        </FormField>
      </ColumnLayout>
    </Container>
  );
}
CustomsItem.propTypes = {
  itemIdx: PropTypes.number.isRequired,
  disableItemEdit: PropTypes.bool,
};
